module.exports = __webpack_public_path__ + "static/media/FOODIE TESTIMONIAL.5d2bfa3c.jpg";